<template>
    <div class="login-container">
      <div class="login-box">
        <h2>RaiseTrack Activation</h2>
        <form @submit.prevent="activateAccount">
          <div class="form-group">
            <label for="activate">Activation code</label>
            <input v-model="verify_code" type="text" id="activate" required />
          </div>
  
          <button type="submit" :disabled="loading">
            {{ loading ? 'Activating...' : 'Activate' }}
          </button>
  
          <div class="text-center mt-4 text-sm text-gray-500">
            Already activated?
            <router-link to="/login" class="text-blue-600 hover:underline font-medium">
              Login
            </router-link>
          </div>
        </form>
  
        <p v-if="message" class="success">{{ message }}</p>
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        verify_code: '',
        loading: false,
        message: '',
        errorMessage: '',
      };
    },
    methods: {
      async activateAccount() {
        this.loading = true;
        this.message = '';
        this.errorMessage = '';
  
        try {
          const response = await axios.post('https://api.roberms.com/fundraise/activate', {
            verify_code: this.verify_code,
          });
  
          this.message = response.data.message || 'Account successfully activated.';
          this.verify_code = '';
  
          // Optional: Delay before redirecting
          setTimeout(() => {
            this.$router.push("/login");
          }, 2000);
  
        } catch (err) {
          this.errorMessage = err.response.data.message || 'Something went wrong.';
        } finally {
          this.loading = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: #f5f5f5;
  }
  .login-box {
    background: white;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    width: 350px;
  }
  h2 {
    text-align: center;
    margin-bottom: 1.5rem;
  }
  .form-group {
    margin-bottom: 1rem;
  }
  label {
    display: block;
    margin-bottom: 0.3rem;
  }
  input {
    width: 100%;
    padding: 0.6rem;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  button {
    width: 100%;
    padding: 0.7rem;
    background: #007bff;
    border: none;
    color: white;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
  }
  button:hover {
    background: #0056b3;
  }
  .error {
    color: red;
    text-align: center;
    margin-top: 1rem;
  }
  .success {
    color: green;
    text-align: center;
    margin-top: 1rem;
  }
  </style>
  